import React from 'react';
import { Chip, makeStyles, Theme } from '../../../index';
import { FilterChipProps } from '../models/transferListProps.types';
import { CurrentFilterType } from '../models/transferList.types';

const useStyles = makeStyles((theme: Theme) => ({
  chipContainer: {
    marginBottom: theme.spacing(2),
    minHeight: theme.spacing(4),
  },
  chipItem: {
    display: 'inline-block',
    marginRight: theme.spacing(1),
  },
  filterChipDefault: {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
}));

export const FilterChips = ({ currentFilters = [], setCurrentFilters }: FilterChipProps): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.chipContainer} data-testid={'FilterChips-component'}>
      {currentFilters
        .filter((item) => item.value !== 'NONE')
        .map((filter: CurrentFilterType, index: number) => (
          <div className={classes.chipItem} key={index}>
            <Chip
              data-testid={'FilterChips-chip-button'}
              label={`${filter.label}: ${filter.value === 'ALL' ? 'Not Specified' : filter.value}`}
              onDelete={() => setCurrentFilters(currentFilters.filter((item) => item !== filter))}
              color={'primary'}
            />
          </div>
        ))}
    </div>
  );
};
